import Reporting from ".";
import OrdersReporting from "./OrdersReporting";
import SpamReport from "../../../../components/sections/front/enquiry/SpamReport";
import EventReports from "../../../../components/sections/front/EventReport";
import OrderManage from "../../../../components/sections/front/EventReport/OrderManagement/OrderManagement";
import SaleManage from "../../../../components/sections/front/EventReport/SaleManagement/SaleManagement";
import TicketSaleManage from "../../../../components/sections/front/EventReport/TicketSaleManagement/TicketSaleManagement";
import AttendeeManage from "../../../../components/sections/front/EventReport/AttendeeManagement/AttendeeManagement";
import AttendeeAddonManage from "../../../../components/sections/front/EventReport/AttendeeAddonManagement/AttendeeAddonManagement";
import SalesReporting from "./SalesReporting";
import TicketsReporting from "./TicketsReporting";
import AttendeesReporting from "./AttendeesReporting";
import AddOnsReporting from "./AddOnsReporting";

export const reportingUserRoutes = (data) => {
  const user_role_in_org = data?.selectedOrganization?.verificationData?.role; //promoter||"admin"||"staff"
  if (user_role_in_org === "promoter") {
    return [];
  }
  return [
    {
      path: "/:lang/user/reporting",
      title: "reporting",
      layout: "user",
      routeType: "organization",
      component: Reporting,
    },
    // {
    //   path: "/:lang/user/reporting/:orgId",
    //   title: "reporting",
    //   layout: "user",
    //   routeType: "organization",
    //   component: OrganizationReports,
    // },
    {
      path: "/:lang/user/customer_reports/:eventId",
      title: "Customer Reports",
      layout: "frontUserInner",
      routeType: "organization",
      component: SpamReport,
    },
    {
      path: "/:lang/user/myEvent/report/:eventId",
      title: "Event Reports",
      layout: "frontUserInner",
      routeType: "organization",
      component: EventReports,
    },
    {
      path: "/:lang/user/myEvent/report/order-reports/:eventId",
      title: "Event Orders",
      layout: "frontUserInner",
      routeType: "organization",
      component: OrderManage,
    },
    {
      path: "/:lang/user/myEvent/report/order-sales/:eventId",
      title: "Event Sales",
      layout: "frontUserInner",
      routeType: "organization",
      component: SaleManage,
    },
    {
      path: "/:lang/user/myEvent/report/tickets-sales/:eventId",
      title: "Ticket Sales",
      layout: "frontUserInner",
      routeType: "organization",
      component: TicketSaleManage,
    },
    {
      path: "/:lang/user/myEvent/report/attendee/:eventId",
      title: "Ticket Sales",
      layout: "frontUserInner",
      routeType: "organization",
      component: AttendeeManage,
    },
    {
      path: "/:lang/user/myEvent/report/attendee-addon/:eventId",
      title: "Ticket Sales",
      layout: "frontUserInner",
      routeType: "organization",
      component: AttendeeAddonManage,
    },
    {
      path: "/:lang/user/reporting/organisation-reports/orders",
      title: "Orders",
      layout: "user",
      routeType: "organization",
      component: OrdersReporting,
    },
    {
      path: "/:lang/user/reporting/organisation-reports/sales",
      title: "Sales",
      layout: "user",
      routeType: "organization",
      component: SalesReporting,
    },
    {
      path: "/:lang/user/reporting/organisation-reports/ticket-type",
      title: "ticket-type",
      layout: "user",
      routeType: "organization",
      component: TicketsReporting,
    },
    {
      path: "/:lang/user/reporting/organisation-reports/attendees",
      title: "attendees",
      layout: "user",
      routeType: "organization",
      component: AttendeesReporting,
    },
    // =================>
    {
      path: "/:lang/user/reporting/organisation-reports/add-ons",
      title: "add-ons",
      layout: "user",
      routeType: "organization",
      component: AddOnsReporting,
    },
  ];
};
